import React from "react";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import OPDTable from "./OpdTable"

const OPDTableContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <OPDTable />
      </div>
    </div>
  )
}

export default OPDTableContainer;
